import type { KeyboardEvent, RefObject } from 'react';

interface ContactStartWithFieldProps {
    value: string;
    onChange: (value: string) => void;
    startWith: string;
    onlyNumber?: boolean;
    disabled?: boolean;
    autoFocus?: boolean;
    className?: string;
    inputRef?: RefObject<HTMLInputElement | null>;
    onBlur?: () => void;
    onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
}

export const applyStartWithValue = (raw: string, startWith: string, onlyNumber?: boolean): string => {
    let v = raw ?? '';

    if (onlyNumber) {
        v = v.replace(/(?!^)\+/g, '');
        v = v.replace(/[^0-9+]/g, '');
    } else {
        v = v.replace(/[^a-zA-Z0-9._\-:/]/g, '');
    }

    const esc = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    if (startWith.startsWith(v) || v.startsWith(startWith)) {
        const reMany = new RegExp(`^(?:${esc(startWith)})+`);
        return v.replace(reMany, startWith);
    }

    if (v === '') return '';

    return startWith + v;
};

const ContactStartWithField = ({
    value,
    onChange,
    startWith,
    onlyNumber,
    disabled,
    autoFocus,
    className = 'form-control',
    inputRef,
    onBlur,
    onKeyDown,
}: ContactStartWithFieldProps) => (
    <input
        ref={inputRef}
        autoFocus={autoFocus}
        disabled={disabled}
        type="text"
        className={className}
        value={value ?? ''}
        placeholder={startWith}
        onChange={(e) => onChange(applyStartWithValue(e.target.value, startWith, onlyNumber))}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
    />
);

export default ContactStartWithField;
